<template>
    <div>
        <div
            :class="preCls + 'filter'"
            style="display: flex; align-items: center; margin-bottom: 20px"
        >
            <form-lookup
                style="min-width: 262px; margin-right: 15px"
                v-model="selectRoom.roomId"
                :options.sync="selectRoom.roomId"
                placeholder="房源名称"
                title="选择房间"
                textSymbol="title"
                valueSymbol="id"
                :modalHeight="600"
                :modalWidth="900"
                @change="onSelectRoom"
                @clear="onClearRoom"
                @deselect="onDeselectRoom"
            >
                <select-room />
            </form-lookup>
            <Select
                style="width: 100px; margin-right: 15px"
                v-model="filter.repairStatus"
                placeholder="工单状态"
                @on-change="search"
                clearable
            >
                <Option
                    v-for="item in repairStatusList"
                    :value="item.id"
                    :key="item.id"
                >
                    {{ item.text }}
                </Option>
            </Select>
            <!--            <Select-->
            <!--                style="width: 120px; margin-right: 15px"-->
            <!--                v-model="filter.repairType"-->
            <!--                placeholder="维修类型"-->
            <!--                @on-change="search"-->
            <!--                clearable-->
            <!--            >-->
            <!--                <Option-->
            <!--                    v-for="item in dict.repairType.toList()"-->
            <!--                    :value="item.id"-->
            <!--                    :key="item.id"-->
            <!--                >-->
            <!--                    {{ item.text }}-->
            <!--                </Option>-->
            <!--            </Select>-->
            <Select
                style="width: 100px; margin-right: 15px"
                v-model="filter.repairPayStatus"
                placeholder="交费状态"
                @on-change="search"
                clearable
            >
                <Option
                    v-for="item in dict.repairPayStatus.toList()"
                    :value="item.id"
                    :key="item.id"
                >
                    {{ item.text }}
                </Option>
            </Select>
            <filter-date-range
                :startDate.sync="filter.startDate"
                :endDate.sync="filter.endDate"
                @on-change="search"
            ></filter-date-range>
        </div>
        <!-- 列表工具栏 -->
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.keyword"
                    placeholder="请输入工单号、联系人姓名和手机号"
                    style="margin-left: 10px"
                    @search="search"
                >
                    搜索
                </table-searcher>
            </template>
            <Button
                v-if="$can('add') && showAdd"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                type="primary"
                @click="onClickAdd"
            >
                新增
            </Button>
            <Button
                v-if="showFresh"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                type="primary"
                @click="search"
            >
                刷新
            </Button>
            <Button
                v-if="$can('view')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                @click="onClickExport"
            >
                导出Excel
            </Button>
        </table-tool-bar>

        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <template v-slot:repairStatus="{ row }">
                <tag-status
                    :text="row.repairStatusAttr.text"
                    :color="row.repairStatusAttr.color"
                    :background="row.repairStatusAttr.background"
                    circle
                />
            </template>
            <template v-slot:reserveTime="{ row }">
                {{ row.reserveDate }}
                {{ dict.reserveTime.get(row.reserveTime).text }}
            </template>
            <!-- 操作列 row.repairStatusAttr.buttons -->
            <template v-slot:action="{ row }">
                <!--超过3个按钮要用dropdown方式显示-->
                <template v-if="row.repairStatusAttr.buttons.length > 3">
                    <template
                        v-if="$can(item.access)"
                        v-for="(
                            item, index
                        ) in row.repairStatusAttr.buttons.slice(0, 2)"
                    >
                        <PoptipButton
                            :key="index"
                            v-if="item.type === 'poptip'"
                            :text="item.text"
                            transfer
                            placement="top-end"
                            type="default"
                            title="您确定要接受吗？"
                            :ok="() => rowClick(row, item.id)"
                        ></PoptipButton>
                        <Button
                            v-else
                            :key="index"
                            type="default"
                            size="small"
                            style="margin-right: 5px"
                            @click="rowClick(row, item.id)"
                        >
                            {{ item.text }}
                        </Button>
                    </template>
                    <Dropdown
                        transfer
                        @on-click="
                            (btnId) => {
                                rowClick(row, btnId)
                            }
                        "
                    >
                        <Button type="default" size="small"> 更多</Button>
                        <DropdownMenu slot="list">
                            <DropdownItem
                                v-if="$can(item.access)"
                                :key="index"
                                v-for="(
                                    item, index
                                ) in row.repairStatusAttr.buttons.slice(2)"
                                :name="item.id"
                            >
                                {{ item.text }}
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </template>
                <template v-else>
                    <template
                        v-if="$can(item.access)"
                        v-for="(item, index) in row.repairStatusAttr.buttons"
                    >
                        <PoptipButton
                            :key="index"
                            v-if="item.type === 'poptip'"
                            :text="item.text"
                            transfer
                            placement="top-end"
                            style="margin-right: 5px"
                            type="default"
                            title="您确定要接受吗？"
                            :ok="() => rowClick(row, item.id)"
                        ></PoptipButton>
                        <Button
                            v-else
                            :key="index"
                            type="default"
                            size="small"
                            style="margin-right: 5px"
                            @click="rowClick(row, item.id)"
                        >
                            {{ item.text }}
                        </Button>
                    </template>
                </template>
            </template>
            <template v-slot:amount="{ row }">
                <template v-if="row.amount !== null">
                    {{ (row.amount / 100) | currency }}
                </template>
            </template>
        </Table>
        <table-pager
            :total="page.totalCount"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.page"
            @change="fetch"
        />
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showForm"
            :title="actionTitle + '工单'"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="fetch"
        >
            <repair-form
                v-if="modal.showForm"
                :id="curId"
                :actionType="actionType"
            />
        </smart-modal>
        <!-- 弹出层 cancel -->
        <smart-modal
            v-model="modal.showCancelForm"
            title="取消工单"
            :width="800"
            :height="300"
            :maskClosable="false"
            @close-by-confirm="fetch"
        >
            <repair-cancel-form v-if="modal.showCancelForm" :id="curId" />
        </smart-modal>
        <!-- 弹出层 addfee -->
        <smart-modal
            v-model="modal.showAddFeeForm"
            title="维修费用"
            :width="800"
            :height="400"
            :maskClosable="false"
            @close-by-confirm="fetch"
        >
            <repair-addfee-form
                v-if="modal.showAddFeeForm"
                :id="curId"
                @second-confirm="search"
            />
        </smart-modal>
        <!-- 弹出层 addFeedback -->
        <smart-modal
            v-model="modal.showAddFeedbackForm"
            title="维修反馈"
            :width="800"
            :height="500"
            :maskClosable="false"
            @close-by-confirm="fetch"
        >
            <repair-addfeedback-form
                v-if="modal.showAddFeedbackForm"
                :id="curId"
            />
        </smart-modal>
        <!-- 弹出框-提示 -->
        <alert
            :text="alert.msg"
            v-model="alert.show"
            @closeAlter="onAlertClose"
        />
    </div>
</template>
<script>
import { mapCache } from '@/plugins/vux-data-cache'
import { mapCell, pipeCell } from '_c/grid/renderCell'
import repairForm from '_v/daily/repair-form'
import repairCancelForm from '_v/daily/repair-cancel-form'
import repairAddfeeForm from '_v/daily/repair-addfee-form'
import repairAddfeedbackForm from '_v/daily/repair-addfeedback-form'
import TagStatus from '_vc/tag-status'
import FilterDateRange from '_v/components/filter/filter-date-range'

import mList from '_v/common/m-list'
import { ymd } from '_u/helper'
import { repairList, repairReceive } from '@/api/repair'
import SelectRoom from '_vc/select-room'
import Alert from '_v/components/alter'

export default {
    name: 'repair-list',
    mixins: [mList],
    components: {
        repairForm,
        TagStatus,
        SelectRoom,
        repairCancelForm,
        repairAddfeeForm,
        repairAddfeedbackForm,
        Alert,
        FilterDateRange,
    },
    data() {
        return {
            curId: '',
            actionType: '', // 1 新增; 2 查看; 3 修改;
            dict: {
                repairStatus: this.$dict.NULL,
                reserveTime: this.$dict.NULL,
                repairPayStatus: this.$dict.NULL,
                repairType: this.$dict.NULL,
                actionType: this.$dict.NULL,
            },
            modal: {
                showForm: false,
                showCancelForm: false,
                showAddFeeForm: false,
                showAddFeedbackForm: false,
            },
            page: {
                totalCount: 0,
                list: [],
            },
            repairStatusList: [],
            loading: false,
            mtHeight: 360,

            /*
            列表操作按钮显示方案：
            - 在"维修状态"的词典里,配置每个状态需要显示各个按钮的id数组
            - this.actionButtons为全量按钮集合
            - 在fetch()时,page.list.forEach设置每行数据所能显示的按钮
            - 部分按钮还有其他逻辑控制显示,详见isShow
             */
            actionButtons: [
                {
                    id: 'view',
                    text: '详情',
                    access: 'view',
                    isShow(row) {
                        return true
                    },
                },
                {
                    id: 'accept',
                    text: '接受工单',
                    access: 'accept',
                    type: 'poptip',
                    isShow(row) {
                        return true
                    },
                },
                {
                    id: 'cancel',
                    text: '取消工单',
                    access: 'cancel',
                    isShow(row) {
                        return true
                    },
                },
                {
                    id: 'addFee',
                    text: '维修费用',
                    access: 'addFee',
                    isShow(row) {
                        return true
                    },
                },
                {
                    id: 'addFeedback',
                    text: '反馈进度',
                    access: 'addFeedback',
                    isShow(row) {
                        return true
                    },
                },
                {
                    id: 'viewFee',
                    text: '查看费用',
                    access: 'viewFee',
                    isShow(row) {
                        return !!row.feeId
                    },
                },
                {
                    id: 'viewFeedback',
                    text: '查看反馈',
                    access: 'viewFeedback',
                    isShow(row) {
                        return !!row.feedBackId
                    },
                },
                {
                    id: 'viewAssess',
                    text: '查看点评',
                    access: 'viewAssess',
                    isShow(row) {
                        return !!row.assessId
                    },
                },
            ],
            alert: {
                msg: '',
                show: false,
            },
        }
    },
    computed: {
        ...mapCache({
            filter: 'repairCache', //将要缓存的改成本地命名
            selectRoom: 'selectRoomRepair',
        }),
        columns() {
            return [
                {
                    type: 'index',
                    width: 80,
                    title: '序号',
                    align: 'center',
                },
                {
                    title: '工单号',
                    key: 'repairNo',
                    align: 'center',
                    minWidth: 170,
                    tooltip: true,
                },
                {
                    title: '联系人姓名',
                    key: 'cusName',
                    align: 'left',
                    minWidth: 90,
                    tooltip: true,
                },
                {
                    title: '联系人手机号',
                    key: 'cusMobile',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    title: '房源名称',
                    key: 'houseNameStr',
                    align: 'left',
                    minWidth: 150,
                    tooltip: true,
                },
                {
                    title: '期望上门时间',
                    key: 'reserveTime',
                    align: 'center',
                    minWidth: 180,
                    slot: 'reserveTime',
                    tooltip: true,
                },
                {
                    title: '状态',
                    key: 'repairStatus',
                    align: 'center',
                    minWidth: 120,
                    slot: 'repairStatus',
                },
                {
                    title: '维修类型',
                    key: 'repairTypeStr',
                    align: 'center',
                    minWidth: 100,
                    tooltip: true,
                },
                {
                    title: '问题描述',
                    key: 'description',
                    align: 'left',
                    minWidth: 200,
                    tooltip: true,
                },
                {
                    title: '费用总额',
                    key: 'amount', // 1000  / 100
                    align: 'right',
                    minWidth: 100,
                    slot: 'amount',
                    // render: pipeCell('divide100|currency'),
                },
                {
                    title: '交费状态',
                    key: 'repairPayStatus',
                    align: 'center',
                    minWidth: 100,
                    render: mapCell(this.dict.repairPayStatus.toList()),
                },
                {
                    title: '报修人',
                    key: 'reportUser',
                    align: 'left',
                    minWidth: 90,
                    tooltip: true,
                },
                {
                    title: '报修时间',
                    key: 'createTime',
                    align: 'center',
                    minWidth: 160,
                    render: pipeCell('ymdL'),
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 230,
                    fixed: 'right',
                    slot: 'action',
                },
            ]
        },
        actionTitle() {
            return this.dict.actionType.val(this.actionType)
        },

        showFresh() {
            return process.env.VUE_APP_TABLE_SHOW_REFRESH_BTN === '1'
        },
        showAdd() {
            // return process.env.NODE_ENV === 'development'
            return true
        },
    },
    methods: {
        fetch() {
            this.loading = true
            Promise.all([repairList(this.filter)])
                .then((args) => {
                    var [view] = args
                    this.resolveRepairList(view.data.page.list)
                    this.page.list = view.data.page.list
                    this.page.totalCount = parseInt(view.data.page.totalCount)
                })
                .finally(() => (this.loading = false))
        },
        resolveRepairList(list) {
            list.forEach((row) => {
                //维修类型
                row.repairTypeStr =
                    row.repairType
                        ?.split(',')
                        .map((k) => this.dict.repairType.val(k))
                        .join() || ''
                //维修状态
                const rdict = this.dict.repairStatus.get(row.repairStatus)
                if (rdict.remark) {
                    const rdictRemark = JSON.parse(rdict.remark)
                    row.repairStatusAttr = {
                        text: rdict.text,
                        background: rdictRemark.background,
                        color: rdictRemark.color,
                    }
                    row.repairStatusAttr.buttons = rdictRemark.buttons
                        .map((id) => {
                            const btn = this.actionButtons.find(
                                (o) => o.id === id
                            )
                            return btn.isShow(row) ? btn : undefined
                        })
                        .filter((o) => o)
                }
                //房源名称
                row.houseNameStr =
                    row.houseName.indexOf('(') === -1
                        ? row.houseName
                        : row.houseName.substring(0, row.houseName.indexOf('('))
            })
        },
        search() {
            this.filter.page = 1
            this.fetch()
        },
        // 导出数据处理
        onClickExport() {
            this.$refs.mt.exportToExcel({
                rows: this.page.list.map((data, index) => {
                    let pageData = Object.assign({}, data)
                    pageData.invoiceTime = ymd(pageData.invoiceTime)
                    return pageData
                }),
            })
        },
        onClickAdd() {
            this.actionType = '1'
            this.curId = ''
            this.modal.showForm = true
        },
        rowClick(row, btnId) {
            this.curId = row.id
            switch (btnId) {
                case 'view':
                    this.actionView(row)
                    break
                case 'viewFee':
                    this.actionAddFee(row)
                    break
                case 'viewFeedback':
                    this.actionFeedback(row)
                    break
                case 'viewAssess':
                    break
                case 'accept':
                    this.actionAccept(row)
                    break
                case 'cancel':
                    this.actionCancel(row)
                    break
                case 'addFee':
                    this.actionAddFee(row)
                    break
                case 'addFeedback':
                    this.actionFeedback(row)
                    break
            }
        },
        actionView(row) {
            this.actionType = '2'
            this.modal.showForm = true
        },
        actionAccept(row) {
            this.loading = true
            // clog(row)
            repairReceive(row.id)
                .then((r) => {
                    this.$Message.success('已接受')
                    this.fetch()
                })
                .finally((_) => {
                    this.loading = false
                })
        },
        actionCancel(row) {
            this.modal.showCancelForm = true
        },
        actionAddFee(row) {
            //增加拦截功能
            if (row.reportUserType === '1') {
                this.alert = {
                    msg: '管理员发起的维修不能收款',
                    show: true,
                }
            } else {
                this.modal.showAddFeeForm = true
            }
        },
        actionFeedback(row) {
            if (!!row.repairPayStatus) {
                //存在支付状态
                if (row.repairPayStatus === '2') {
                    this.curId = row.id
                    this.modal.showAddFeedbackForm = true
                } else {
                    this.alert = {
                        msg: '租客未交清费用，无法反馈情况',
                        show: true,
                    }
                }
            } else {
                this.curId = row.id
                this.modal.showAddFeedbackForm = true
            }
        },
        onAlertClose() {
            this.alert.show = false
        },
    },
    created() {
        this.loading = true
        Promise.all([
            this.$dict.get([
                'repair_pay_status',
                'repair_status',
                'reserve_time',
                'repair_type',
                'action_type',
            ]),
        ]).then((r) => {
            const [dict] = r
            Object.assign(this.dict, dict)
            this.repairStatusList = dict.repairStatus.toList()
            this.repairStatusList.shift()
            this.fetch()
        })
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
}
</script>
